import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import {
  capitalizeWords,
  capitalize,
} from "../../../utils/capitalize/capitalizeWord";
import {
  saveIntoServerCache,
  getOneFromServerCache,
} from "../../../utils/saveIntoCache";
import { ToastContainer, toast } from "react-toastify";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/en";
import TextEditor from "../components/TextArea";
import MicIcon from "@mui/icons-material/Mic";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import {
  dispatchActivites,
  generate_experience,
  cleanEX,
  currentExperience,
  currentExperience_loading,
  current_skills_loading,
  updateExperience,
} from "../../../Redux/ActionCreator";
import { useSelector, useDispatch } from "react-redux";
import LoaderModal from "../../common/LoaderModal/index.jsx";
import { extractLatestThreeExperiences } from "../../../utils/skillsService/index.js";
dayjs.extend(customParseFormat);
dayjs.locale("en");
import { computeTotalExperience } from "../../../utils/experience"

const EditExperience = ({ handleClick }) => {
  const dispatch = useDispatch();
  const [openSection2, setOpenSection2] = useState(true);
  const [openSection3, setOpenSection3] = useState(true);
  const [companyName, setCompanyName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  let [experience, setExperience] = useState("");
  const [isCurrentJob, setIsCurrentJob] = useState(false);
  const flowLanguage = useSelector((e) => e.t_lang.selected);
  const expText = useSelector((ai) => ai.exp);
  let Tags = useSelector((e) => e.tags);
  const p_profile = useSelector((e) => e.profile);
  const [fill, setFill] = useState(null);
  const current_skills = useSelector((e) => e.current_skills);

  const exp = useSelector((exp) => exp.activities);
  const currentExp = useSelector((exp) => exp.currentExperience);
  const [loading, setLoading] = useState(false);
  const Tech_skills = useSelector((e) => e.skills);
  let [mappedExp, setMappedExp] = useState(null);

  // **Function to Convert Formatted String Back to Dayjs**
  // const parseFormattedDate = (dateString) => {
  //   return dateString ? dayjs(dateString, "MMM YYYY") : null;
  // };
  const parseFormattedDate = (dateString) => {
    // console.log("dateString (raw):", dateString);
    try {
      if (dateString) {
        const parts = dateString?.trim()?.split(" ");
        if (parts.length !== 2) {
          throw new Error("Invalid date format: Expected 'Month Year'");
        }
        const month =
          parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase();
        const year = parts[1];
        const normalized = `${month} ${year}`;
        // console.log("dateString (normalized):", normalized);

        // Try full month format first
        let parsed = dayjs(normalized, "MMMM YYYY", true);
        if (!parsed?.isValid()) {
          // If full month fails, try abbreviated format
          parsed = dayjs(normalized, "MMM YYYY", true);
        }

        // console.log(
        //   "Parsed result:",
        //   parsed.toString(),
        //   "isValid:",
        //   parsed.isValid()
        // );
        return parsed?.isValid() ? parsed : null;
      }
    } catch (error) {
      console.error("Error parsing date:", error);
    }
    return null;
  };

  useEffect(() => {
    if (window.location.pathname.includes("/user/profile")) {
      if (
        p_profile.message !== null &&
        p_profile.message?.Experience?.length !== 0
      ) {
        dispatch(dispatchActivites(p_profile.message?.Experience));
      }
    }
  }, []);

  useEffect(() => {
    if (currentExp.message !== null) {
      let info = currentExp.message;
      setCompanyName(info?.Where_i_worked);
      setJobTitle(info?.My_job_title);
      let start = parseFormattedDate(info?.Work_start_date);
      if (info?.Work_end_date == "Present") setFill("Yes");
      let current_exp_end_date =
        info?.Work_end_date == "Present"
          ? null
          : parseFormattedDate(info?.Work_end_date);
      setEndDate(
        current_exp_end_date !== undefined ? current_exp_end_date : ""
      );
      setStartDate(start);
      if (typeof info?.Day_to_day_work == "string") {
        setExperience(info?.Day_to_day_work);
      } else {
        if (Array.isArray(info?.Day_to_day_work)) {
          setExperience(
            info?.Day_to_day_work !== null
              ? info?.Day_to_day_work?.join(".<br>")
              : ""
          );
        }
      }
    }
  }, [currentExp.message]);

  useEffect(() => {
    if (expText.exp !== null) {
      let experience = expText.exp?.replace(/\n/g, "<br>");
      setExperience(experience);
      let current_Exp_To_Be_Saved = {
        Where_i_worked: companyName,
        // Where_i_worked_location: $('[name="work_place"]').val(),
        My_job_title: jobTitle,
        Work_start_date: startDate?.format("MMM YYYY"),
        Work_end_date:
          isCurrentJob == true ? "Present" : endDate?.format("MMM YYYY"),
        // Review: true,
        Tags: Tags?.message || currentExp.message?.Tags,
        Skills: current_skills?.skills || currentExp.message?.Skills,
        Day_to_day_work: experience || null,
        Tags: Tags?.message,
      };
      dispatch(currentExperience(current_Exp_To_Be_Saved));
      saveIntoServerCache("current_experience", current_Exp_To_Be_Saved);
      setLoading(false);
    }
  }, [expText.exp]);

  const [isListening, setIsListening] = useState(false);
  // Speech Recognition Hook
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();

  useEffect(() => {
    if (transcript !== null && transcript !== undefined && transcript !== "") {
      setExperience(transcript); // Update text editor with recognized speech
    }
  }, [transcript]);

  // Handle Microphone Start/Stop
  const handleMicClick = () => {
    if (!browserSupportsSpeechRecognition) {
      alert("Your browser does not support speech recognition.");
      return;
    }

    if (listening) {
      SpeechRecognition.stopListening();
    } else {
      resetTranscript(); // Reset transcript before starting new speech
      SpeechRecognition.startListening({ continuous: true });
    }
    setIsListening(!isListening);
  };

  const generateExperience = () => {
    dispatch(cleanEX());
    if (listening) {
      SpeechRecognition.stopListening();
    }
    setIsListening(!isListening);
    if (companyName !== "") {
      if (Array.isArray(experience)) {
        // setTruty(true);
        const cred = {
          Experience: experience,
          Language: flowLanguage || "English", // Language,
          CvType: jobTitle,
          workPlace: companyName,
        };
        let count =
          localStorage.getItem("count") !== null
            ? parseInt(JSON.parse(localStorage.getItem("count")), 10)
            : 0;
        localStorage.setItem("count", count + 1);
        dispatch(generate_experience(cred));
        setLoading(true);
      } else if (typeof experience === "string") {
        if (jobTitle === "") {
          setTimeout(() => {
            toast.error("Please enter the experience job title", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }, 50);
        } else if (experience?.split(" ")?.length < 20) {
          setTimeout(() => {
            toast.error(
              "In at least 20 words, breifly describe your daily activity",
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
          }, 50);
        } else if (
          experience !== "" &&
          experience?.split(" ")?.length >= 20 &&
          companyName !== ""
        ) {
          const cred = {
            Experience: experience,
            Language: flowLanguage || "English", // Language,
            CvType: jobTitle,
            workPlace: companyName,
          };
          // let count = localStorage.getItem("count") !== null ? parseInt(JSON.parse(localStorage.getItem("count")), 10) : 0;
          localStorage.setItem("count", 1);
          dispatch(generate_experience(cred));
          setLoading(true);
        } else {
          return false;
        }
      }
      // }
    }
    return;
  };

  const handleCancel = () => {
    let allExperience = exp.activities;
    let newExp = allExperience.filter(
      (element) =>
        element?.Day_to_day_work !== "" &&
        element?.Where_i_worked !== null &&
        element?.Work_start_date !== null
    );
    dispatch(dispatchActivites(newExp));
    handleClick();
  };

  const handleGenerateExperience = async () => {
    try {
      generateExperience();
    } catch (error) {
      console.log("Error while trying to generate experience", error);
    }
  };

  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState(0);
  let [prevKey, setPrevKey] = useState(null);

  // const handlePrevKey = (key) => {
  //   if (prevKey == null) {
  //     setPrevKey(key);
  //   } else {
  //     setPrevKey(key);
  //   }
  // }

  const stripHtmlTags = (html) => {
    let sent = html?.replace(/<\/?p>|<br\s*\/?>/g, ""); // Extract plain
    return sent;
  };

  function customSplit(str) {
    if (str?.includes(".")) {
      return str
        ?.split(".")
        ?.map((s) => s.trim())
        .filter(Boolean);
    } else {
      // Split on one or more whitespace characters that precede an uppercase letter.
      return str
        ?.split(/\s+(?=[A-Z])/)
        ?.map((s) => s.trim())
        .filter(Boolean);
    }
  }

  function onDelete(key) {
    try {
      let allExperience = exp.activities;
      let newExp = allExperience.filter(
        (element) => allExperience.indexOf(element) !== key
      );
      dispatch(dispatchActivites(newExp));
    } catch (error) {
      console.log(error);
    }
  }

  const handleSaveCall = () => {
    console.log("isOpen", isOpen);
    console.log("companyName", companyName);
    console.log("jobTitle", jobTitle);
    console.log("experience", experience);
    if (companyName !== "" && jobTitle !== "" && experience !== "") {
      // if (isOpen == true) {
      let stripedExp = stripHtmlTags(experience);
      let striped = customSplit(stripedExp);
      let updatedData = {
        Where_i_worked: companyName,
        // Where_i_worked_location: $('[name="work_place"]').val(),
        My_job_title: jobTitle,
        Work_start_date: startDate?.format("MMM YYYY"),
        Work_end_date: fill === "Yes" ? "Present" : endDate?.format("MMM YYYY"),
        Day_to_day_work: striped,
        // Review: true,
        Tags: Tags?.message || currentExp.message?.Tags,
        Skills: current_skills?.skills || currentExp.message?.Skills,
      };
      let newExp = exp.activities;
      newExp[prevKey] = updatedData;

      dispatch(
        extractLatestThreeExperiences(
          newExp,
          window.location.pathname.includes("/user/profile")
            ? "auto-save"
            : undefined
        )
      ); // dispatch(dispatchActivites(newExp));
      // }
    } else {
      let allExperience = exp.activities;
      let newExp = allExperience.filter(
        (element) =>
          element?.Day_to_day_work !== "" &&
          element?.Where_i_worked !== null &&
          element?.Work_start_date !== null
      );
      dispatch(dispatchActivites(newExp));
      if (window.location.pathname.includes("/user/profile")) {
        dispatch(extractLatestThreeExperiences(newExp, "auto-save"));
      }
    }
    // dispatch(dispatchActivites(exp.activities));
    dispatch(current_skills_loading());
    dispatch(currentExperience_loading());
    dispatch(cleanEX());
    handleClick();
  };

  const handleToggle = (element, key) => {
    console.log("current_skills?.skills", current_skills?.skills);
    if (isOpen == true) {
      let stripedExp = stripHtmlTags(experience);
      let striped = customSplit(stripedExp);
      let updatedData = {
        Where_i_worked: companyName,
        // Where_i_worked_location: $('[name="work_place"]').val(),
        My_job_title: jobTitle,
        Work_start_date: startDate?.format("MMM YYYY"),
        Work_end_date: fill === "Yes" ? "Present" : endDate?.format("MMM YYYY"),
        Day_to_day_work: striped,
        // Review: true,
        Tags: Tags?.message || currentExp.message?.Tags,
        Skills: current_skills?.skills || currentExp.message?.Skills,
      };
      let newExp = exp.activities;
      newExp[prevKey] = updatedData;
      dispatch(dispatchActivites(newExp)); // dispatch(dispatchActivites(newExp));
      if (key !== index) {
        setCompanyName("");
        setJobTitle("");
        setStartDate(dayjs());
        setEndDate(dayjs());
        setExperience("");
      } else {
        setIsOpen(false);
      }
    }
    if (key == exp.activities.indexOf(element)) {
      let expToDispatch = exp.activities[key];
      // expToDispatch.Work_start_date = parseFormattedDate(expToDispatch?.Work_start_date);
      // expToDispatch.Work_end_date = parseFormattedDate(expToDispatch?.Work_end_date);
      dispatch(currentExperience(expToDispatch));
      setIsOpen(true);
      setIndex(key);
      setPrevKey(key);
      setFill("No");
    }
  };

  const handleAddNewExperience = (key) => {
    let newExp = exp.activities || [];
    if (companyName !== "" && jobTitle !== "" && experience !== "") {
      // if (isOpen == true) {
      let stripedExp = stripHtmlTags(experience);
      let striped = customSplit(stripedExp);
      let updatedData = {
        Where_i_worked: companyName,
        // Where_i_worked_location: $('[name="work_place"]').val(),
        My_job_title: jobTitle,
        Work_start_date: startDate?.format("MMM YYYY"),
        Work_end_date: fill === "Yes" ? "Present" : endDate?.format("MMM YYYY"),
        Day_to_day_work: striped,
        // Review: true,
        Tags: Tags?.message || currentExp.message?.Tags,
        Skills: current_skills?.skills || currentExp.message?.Skills,
      };
      // let newExp = exp.activities;
      newExp[key - 1] = updatedData;
    }
    setCompanyName("");
    setJobTitle("");
    setStartDate(dayjs());
    setEndDate(dayjs());
    setExperience("");
    let experienceDate = {
      Where_i_worked: null,
      // Where_i_worked_location: $('[name="work_place"]').val(),
      My_job_title: null,
      Work_start_date: null,
      Work_end_date: null,
      Day_to_day_work: "",
      // Review: true,
      Tags: [],
      Skills: [],
    };

    // let newExp = exp.activities || [];
    newExp[key] = experienceDate;
    console.log(`${newExp[key]}`, experienceDate);
    console.log("newExp", newExp)
    // sort
    function parseEndDate(dateStr) {
      if (
        typeof dateStr === "string" &&
        dateStr.trim().toLowerCase() === "present"
      ) {
        // Use a far-future date to ensure "Present" is always the most recent.
        return new Date(3000, 0, 1); // January 1, 3000
      }
      // For other dates like "January 2023", the Date constructor can parse them.
      return new Date(dateStr);
    }

    // Sort the experiences by Work_end_date in descending order.
    const sortedExperiences = newExp?.sort((a, b) => {
      const dateA = parseEndDate(a.Work_end_date);
      const dateB = parseEndDate(b.Work_end_date);
      return dateB - dateA; // descending order
    });

    dispatch(dispatchActivites(sortedExperiences));
    if (window.location.pathname.includes("/user/profile")) {
      dispatch(extractLatestThreeExperiences(newExp, "auto-save"));
    }
    // dispatch(dispatchActivites(newExp));
    setIsOpen(true);
    setIndex(key);
    setPrevKey(key);
    setFill("No");
  };

  const [showCompanyNamePlaceholder, setShowCompanyNamePlaceholder] =
    useState(true);
  const [showJobTitlePlaceholder, setShowJobTitlePlaceholder] = useState(true);

  return (
    <>
      <div className="bg-transparent px-4 md:px-6 lg:px-8 xl:px-10 py-8 sm:w-[100vw] vsm:w-[100vw] flex justify-center rounded-xl my-6 max-h-[90vh]">
        <div className="sm:w-[100vw] vsm:w-[100vw] gap-y-6 lg:gap-0 lg:h-full flex flex-col lg:justify-between justify-center rounded-lg p-6 md:p-8 h-full">
          {/* Main container/card */}
          <div className="w-full bg-white rounded shadow p-6">
            {/* Heading */}
            <h3 className="text-xl font-bold text-[#5843BD] my-4 text-center">
              Edit work eperience {index + 1}
            </h3>

            {exp.activities !== null &&
              exp.activities?.map((element, key) => (
                <div key={key}>
                  <div className="border-t border-gray-200 py-4 px-4 mb-4 bg-[#F9F4FD] rounded-lg">
                    <div
                      className="flex justify-between items-center cursor-pointer"
                      onClick={() => handleToggle(element, key)}
                    >
                      <h3 className="md:text-xl vsm:text-md font-bold text-[#5843BD] mb-4 text-center w-fit">
                        Experience {key + 1}
                      </h3>
                      <div>
                        {isOpen == true && key === index ? (
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="32"
                              height="32"
                              rx="4"
                              fill="#5843BD"
                            />
                            <path
                              d="M7.95312 18.035V13.9668H15.9986H24.044V18.035H7.95312Z"
                              fill="#E6E9F5"
                            />
                          </svg>
                        ) : (
                          <button className="text-sm bg-[#5843BD] text-white rounded-lg py-2 px-6">
                            Edit
                          </button>
                        )}
                      </div>
                    </div>
                    <h6 className="md:text-lg vsm:text-md  font-semibold text-black mb-4 ">
                      {element?.My_job_title}
                    </h6>
                    <div
                      className="flex items-center gap-2 py-2 px-4 bg-[#FF6633] w-fit rounded-md cursor-pointer"
                      onClick={() => onDelete(key)}
                    >
                      <span className="text-white md:text-xl vsm:text-md ">
                        Delete
                      </span>
                      <svg
                        width="16"
                        height="18"
                        viewBox="0 0 16 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3 18C2.45 18 1.97934 17.8043 1.588 17.413C1.19667 17.0217 1.00067 16.5507 1 16V3C0.71667 3 0.479337 2.904 0.288004 2.712C0.0966702 2.52 0.000670115 2.28267 3.44827e-06 2C-0.000663218 1.71733 0.0953369 1.48 0.288004 1.288C0.48067 1.096 0.718003 1 1 1H5C5 0.716667 5.096 0.479333 5.288 0.288C5.48 0.0966668 5.71734 0.000666667 6 0H10C10.2833 0 10.521 0.0960001 10.713 0.288C10.905 0.48 11.0007 0.717333 11 1H15C15.2833 1 15.521 1.096 15.713 1.288C15.905 1.48 16.0007 1.71733 16 2C15.9993 2.28267 15.9033 2.52033 15.712 2.713C15.5207 2.90567 15.2833 3.00133 15 3V16C15 16.55 14.8043 17.021 14.413 17.413C14.0217 17.805 13.5507 18.0007 13 18H3ZM13 3H3V16H13V3ZM6 14C6.28334 14 6.521 13.904 6.713 13.712C6.905 13.52 7.00067 13.2827 7 13V6C7 5.71667 6.904 5.47933 6.712 5.288C6.52 5.09667 6.28267 5.00067 6 5C5.71734 4.99933 5.48 5.09533 5.288 5.288C5.096 5.48067 5 5.718 5 6V13C5 13.2833 5.096 13.521 5.288 13.713C5.48 13.905 5.71734 14.0007 6 14ZM10 14C10.2833 14 10.521 13.904 10.713 13.712C10.905 13.52 11.0007 13.2827 11 13V6C11 5.71667 10.904 5.47933 10.712 5.288C10.52 5.09667 10.2827 5.00067 10 5C9.71734 4.99933 9.48 5.09533 9.288 5.288C9.096 5.48067 9 5.718 9 6V13C9 13.2833 9.096 13.521 9.288 13.713C9.48 13.905 9.71734 14.0007 10 14Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                  {isOpen && index == key && (
                    <div className="bg-white">
                      <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center my-2">
                        <div
                          className={`flex w-full gap-y-2 vsm:my-4 md:my-0 vsm:justify-center lg:justify-start`}
                        >
                          <div className="lg:w-[400px] vsm:w-full flex vsm:justify-center md:justify-start">
                            <div className="w-full">
                              <label
                                htmlFor="companyName"
                                className="text-black font-medium text-sm mb-2"
                              >
                                What was the company name?
                              </label>
                              <input
                                type="text"
                                id="companyName"
                                className="w-full lg:w-[400px] border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                                value={companyName}
                                onChange={(e) =>
                                  setCompanyName(
                                    capitalizeWords(e.target.value)
                                  )
                                }
                                placeholder={
                                  showCompanyNamePlaceholder == false
                                    ? ""
                                    : "e.g Plumbing Intl"
                                }
                                onFocus={() =>
                                  setShowCompanyNamePlaceholder(false)
                                }
                                onBlur={() =>
                                  setShowCompanyNamePlaceholder(true)
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <div className="flex w-full gap-y-2 vsm:justify-center lg:justify-end">
                          <div className="lg:w-[400px] vsm:w-full flex vsm:justify-center">
                            <div className="w-full">
                              <label
                                htmlFor="jobTitle"
                                className="text-black font-medium text-sm mb-2"
                              >
                                What was your job title?
                              </label>
                              <input
                                type="text"
                                id="jobTitle"
                                className="w-full border-2 lg:w-[400px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                                value={jobTitle}
                                onChange={(e) =>
                                  setJobTitle(capitalizeWords(e.target.value))
                                }
                                placeholder={
                                  showJobTitlePlaceholder == false
                                    ? ""
                                    : "e.g plumber"
                                }
                                onFocus={() =>
                                  setShowJobTitlePlaceholder(false)
                                }
                                onBlur={() => setShowJobTitlePlaceholder(true)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className={`md:flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center ${
                          isCurrentJob ? "md:items-center" : ""
                        } my-4`}
                      >
                        <div className="flex w-full gap-y-2 vsm:my-6 md:my-0 vsm:justify-center lg:justify-start">
                          <div className="lg:w-[400px] vsm:w-full flex vsm:justify-center lg:justify-start">
                            <div className="w-full">
                              <label className="text-black font-medium text-sm mb-2">
                                When did you start this job? (Month & Year)?
                              </label>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DatePicker"]}>
                                  <DatePicker
                                    views={["month", "year"]}
                                    value={startDate}
                                    onChange={(newValue) =>
                                      setStartDate(newValue)
                                    }
                                    className="w-full max-w-full"
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </div>
                          </div>
                        </div>

                        <div className="flex w-full gap-y-2 vsm:justify-center lg:justify-end">
                          <div>
                            <p className="text-black font-medium text-sm mb-2">
                              When did you end this job? (Month & Year)?
                            </p>
                            <div className="lg:w-[400px] vsm:w-full lg:flex vsm:justify-center">
                              <div className="flex items-center w-full lg:mr-2">
                                <div
                                  className="flex items-center justify-center py-3 px-3 border border-[#777DEA54] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent cursor-pointer mr-2 rounded-lg w-full"
                                  onClick={() => setFill("Yes")}
                                >
                                  <div
                                    className={`w-[15px] h-[15px] rounded-[50%] ${
                                      fill == "Yes"
                                        ? "bg-[#FF6633]"
                                        : "bg-white"
                                    } mr-2 border border-[#777DEA54]`}
                                  ></div>
                                  <p className="text-lg font-medium">Yes</p>
                                </div>
                                <div
                                  className="flex items-center justify-center py-3 px-3 border border-[#777DEA54] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent cursor-pointer rounded-lg w-full"
                                  onClick={() => setFill("No")}
                                >
                                  <div
                                    className={`w-[15px] h-[15px] rounded-[50%] ${
                                      fill == "No" ? "bg-[#FF6633]" : "bg-white"
                                    } mr-2 border border-[#777DEA54]`}
                                  ></div>
                                  <p className="text-lg font-medium">No</p>
                                </div>
                              </div>
                              <div className="w-full">
                                {fill == "No" && (
                                  <div>
                                    {/* <label className="text-black font-medium text-sm">
                                When did you end this job? (Month & Year)?
                              </label> */}
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DemoContainer
                                        components={["DatePicker"]}
                                      >
                                        <DatePicker
                                          views={["month", "year"]}
                                          value={endDate}
                                          onChange={(newValue) =>
                                            setEndDate(newValue)
                                          }
                                          className="w-full max-w-full"
                                          minDate={startDate}
                                        />
                                      </DemoContainer>
                                    </LocalizationProvider>
                                  </div>
                                )}
                                {fill == "Yes" && (
                                  <p className="text-lg font-semibold text-white mb-4 py-3 bg-[#FF6633] rounded-lg px-4 vsm:my-2 my-0">
                                    Present
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className=" w-full relative">
                        <label
                          htmlFor="jobTitle"
                          className="text-sm text-black mb-2"
                        >
                          When finished, click 'Generate' and our AI will create
                          your work Experience. Click on the microphone to speak
                          instead.?
                        </label>
                        <div className=" w-full relative">
                          <TextEditor
                            // onCut={(e) => e.preventDefault()}
                            // onCopy={(e) => e.preventDefault()}
                            // onKeyDown={handleKeyDown}
                            className="h-56 w-full xl:w-full 2xl:w-full rounded-lg border border-radius border-indigo-400 border-opacity-30 focus:outline-none focus:border-2 focus:border-indigo-400 placeholder:text-[#B3B3B3] text-4xl font-normal notranslate"
                            style={{ resize: "none" }}
                            placeholder="Start typing or use the microphone..."
                            value={experience}
                            type="text"
                            id="experience"
                            name="experience"
                            onChange={(value) => setExperience(value)}
                            required
                            notranslate
                          />
                          {/* {error && <p className='text-xs text-[#FF6633] font-medium'>{error}</p>} */}
                          {/* Microphone Button */}
                          <motion.button
                            onClick={handleMicClick}
                            className={`absolute top-[8%] right-7 p-1 rounded-full shadow-lg transition duration-300 
                        ${
                          listening
                            ? "bg-red-500 hover:bg-red-600"
                            : "bg-purple-500 hover:bg-purple-600"
                        }`}
                            animate={{
                              scale: [1, 1.3, 1],
                              y: [0, -15, 0],
                              // rotate: [0, 40, -40, 0],
                              filter: [
                                "drop-shadow(0px 0px 0px rgba(255,255,255,0))",
                                "drop-shadow(0px 0px 15px rgba(255,255,255,1))",
                                "drop-shadow(0px 0px 0px rgba(255,255,255,0))",
                              ],
                            }}
                            transition={{
                              duration: 0.5,
                              repeat: Infinity,
                              ease: "easeInOut",
                            }}
                          >
                            <MicIcon className="text-white text-xxl" />
                          </motion.button>
                        </div>
                      </div>

                      {/* Generate Button */}
                      <div className="flex justify-center my-4 w-full">
                        <button
                          className="bg-gradient-to-r from-[#FF6633] to-[#5843BD] text-white font-medium py-3 px-[20px] rounded-[50px] shadow-md hover:from-[#5843BD] hover:to-[#FF6633] transition-colors duration-300 flex items-center justify-center text-xl vsm:w-full md:w-[400px]"
                          onClick={handleGenerateExperience}
                        >
                          GENERATE
                          <span className="ml-2">
                            <img
                              src="https://res.cloudinary.com/drlcisipo/image/upload/v1740040104/Website%20images/moil-white-logo_fndycf.png"
                              alt="Moil white logo"
                            />
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                  {exp.activities?.indexOf(element) ===
                    exp.activities?.length - 1 && (
                    <p
                      className="text-[#5843BD] text-md font-semibold mb-6 cursor-pointer text-center"
                      onClick={() =>
                        handleAddNewExperience(exp.activities?.length)
                      }
                    >
                      <em className="underline">
                        Click here to add new experience
                      </em>
                    </p>
                  )}
                </div>
              ))}

            {exp.activities == null && (
              <p
                className="text-[#5843BD] text-md font-semibold mb-6 cursor-pointer text-center"
                onClick={() => handleAddNewExperience(0)}
              >
                <em className="underline">Click here to add new experience</em>
              </p>
            )}

            {/* Action buttons */}
            <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center my-2">
              <div className="flex justify-between lg:max-w-[90vw] w-full">
                <button
                  onClick={handleCancel}
                  className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 px-4 rounded-md"
                >
                  <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? "Cancelar" : "CANCEL"}
                  </span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="24" height="24" rx="12" fill="#FF6633" />
                    <path
                      d="M15.1893 18C15.1132 18 15.0412 17.9653 14.9938 17.9058L12.0561 14.2175C11.953 14.0881 11.7548 14.0927 11.6579 14.2269L9.00599 17.8964C8.95899 17.9615 8.88362 18 8.80337 18H6.07388C5.86606 18 5.74897 17.7612 5.87625 17.5969L10.132 12.1039C10.2027 12.0127 10.2017 11.8849 10.1297 11.7948L5.82441 6.40605C5.69361 6.24233 5.81018 6 6.01973 6H8.81098C8.88693 6 8.95877 6.03453 9.00621 6.09384L11.9435 9.76586C12.0469 9.89503 12.2449 9.89004 12.3416 9.75583L14.9727 6.10386C15.0197 6.03865 15.0952 6 15.1756 6H17.9053C18.1131 6 18.2302 6.23864 18.1031 6.40295L13.8676 11.8792C13.7971 11.9703 13.798 12.0978 13.8698 12.1879L18.1767 17.5942C18.3072 17.758 18.1906 18 17.9812 18H15.1893Z"
                      fill="white"
                    />
                  </svg>
                </button>
                <button
                  onClick={handleSaveCall}
                  className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md "
                >
                  <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? "GUARDAR" : "SAVE"}
                  </span>
                  <svg
                    width="11"
                    height="18"
                    viewBox="0 0 11 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.5 8.99891L1.5 16.3789"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.5 9L1.5 1.62"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && (
        <LoaderModal text="Our AI tool is generating a standard experience description for you. Kindly wait a minute..." />
      )}
    </>
  );
};

export default EditExperience;
